var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" 幻水総選挙 2020 ("),_c('a',{attrs:{"href":"https://twitter.com/gensosenkyo","target":"_blank"}},[_vm._v("@gensosenkyo")]),_vm._v(") ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }